/**
 * Groups of filters
 * @typedef {object} MultiDataFilterGroup
 * @property {string} label Label of the group
 * @property {MultiDataFilterOption[]} options Group options
 */
export type MultiDataFilterGroup = {
    /**
     * Label of the group
     */
    label: string;
    options: MultiDataFilterOption[];
};

type MultiDataFilterOption = { label: string; value: string; defaultChecked?: boolean };

/**
 * Format default chosen options data, based on prop passed filterGroups
 *
 * @param filterGroups
 * @returns
 */
export const getDefaultChosenOptions = (filterGroups: MultiDataFilterGroup[]) => {
    const defaultChosenOptions = filterGroups.reduce((chosenOptions, group) => {
        const defaultCheckedOption = group.options.find((option) => option.defaultChecked);

        if (defaultCheckedOption) chosenOptions[group.label] = defaultCheckedOption.value;

        return chosenOptions;
    }, {});
    return defaultChosenOptions as MultiDataFiltersChosenOption;
};

export type MultiDataFiltersChosenOption = Record<string, string>;
